import { cookiesConsent } from './helpers/cookies_consent';

// ! Cookies consent
const cookiesPopup = document.querySelector('#cookies');
const allowBtnCookies = document.querySelector('.cookies_consent_btn');
const cookiesName = 'thermoconfort';

if (cookiesPopup && allowBtnCookies && cookiesName) {
    cookiesConsent(cookiesPopup, allowBtnCookies, cookiesName);
}

// const buttonBurger = document.querySelector(".q10__header__top__burger_menu");
// const burgerMenu = document.querySelector(".q10__header__popup");
// const closeNav = document.querySelector(".close_popup");

// buttonBurger.addEventListener("click", (e) => {
//     burgerMenu.classList.add("active")
//     document.body.style.overflow = "hidden";

// });
// closeNav.addEventListener("click", (e) => {
//     burgerMenu.classList.remove("active");
//     document.body.style.overflow = "auto";
// });


function scrollTop() {
    const scrollTop = document.querySelector(".scrolltop");
    if (this.scrollY >= 560) scrollTop.classList.add("show-scroll");
    else scrollTop.classList.remove("show-scroll");
}
window.addEventListener("scroll", scrollTop);


window.openVertical= function(){
    var targetNavMenu = document.querySelector('.q10__header__top__menu');
    var closeXVertical = document.querySelector('.close_x_vertical');
    var whiteDotsVertical = document.querySelector('.black_dots_vertical');
    if (targetNavMenu.style.display !== "flex") {
        targetNavMenu.style.display = "flex";
        closeXVertical.style.display = "flex";
        whiteDotsVertical.style.display = "none";

        } else if (targetNavMenu.style.display !== "none") {
            targetNavMenu.style.display = "none";
            closeXVertical.style.display = "none";
            whiteDotsVertical.style.display = "block";
        }
}


window.openMenu= function(){
    var targetMenu = document.querySelector(".dropdown-content")
    var selectMenu = document.querySelector("#selected")
    if (targetMenu.style.display === "block") {
    targetMenu.style.display = "none";
    selectMenu.style = "box-shadow: 0;"
    } else {
    targetMenu.style.display = "block";
    
    selectMenu.style = "box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;"
    }
}

window.addEventListener("resize", openMenu);
//check if resonsive and hide menu for Mobile

window.addDisplayFlexOnDesktop = function() {
//Close slect Menu (targetNameAndIcon), at resizing
var whiteDotsVertical = document.querySelector('.black_dots_vertical');
var targetMenu = document.querySelector(".dropdown-content");
var targetNameAndIcon = document.querySelector('#selected');
var closeXVertical = document.querySelector('.close_x_vertical');
targetNameAndIcon.style.display = 'none';
targetNameAndIcon.style = 'box-shadow: none';
var targetNavMenu = document.querySelector('.q10__header__top__menu');
var responsiveCheck = window.matchMedia("(min-width: 1025px)")
    if (responsiveCheck.matches) { // If media query matches
        targetMenu.style.display = "flex";
        targetNavMenu.style.display = "flex";
    } else {
        targetMenu.style.display = "none";
        targetNavMenu.style.display = "none";
        closeXVertical.style.display = "none";
        whiteDotsVertical.style.display = "block";
    }
}
//Make function above listen to resize window
window.addEventListener('resize', addDisplayFlexOnDesktop);